// import logo from './logo.svg';
import "./Services.css";

function Services() {
  return (
    <>
      <div className="Services">
        <div id="hw-hero">
          <div id="page-header" className="services3">
            <div className="title-breadcrumbs">
              <h1>SERVICES</h1>
              <div className="thebreadcumb">
                <ul className="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  {/* <li>Pages</li>
                  <li>Services</li> */}
                  <li className="active">SERVICES</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <section className="introtext">
          <div className="row">
            <div className="col-sm-12">
              <h2>
                WHAT WE CAN OFFER YOU?
                {/* <span>DAY-TO-DAY</span> ACCOUNTING */}
              </h2>

              <p className="text-center">
                V T THOMAS & ASSOCIATES IS A LEADING TAX CONSULTANCY AND
                MANAGEMENT CONSULTANCY FIRM BASED OUT IN KATTAPPANA IDUKKI
                KERALA. V T THOMAS AND ASSOCIATES HAVE its ORIGIN since 1982.
              </p>

              <p className="text-center">
                We provide full range of accounting,taxation ,management, and
                financial service geared towards assisting all sectors.
              </p>
              <p className="text-center">
                we focus on quality,we are offering services of individual
                firm,company,partnership firm ,patent registration,income tax
                and sales tax returns, accounts management,business
                management,etc
              </p>

              <hr className="small" />
            </div>
          </div>
        </section>

        <section className="services3-list">
          <div className="row">
            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-chart-line"></span>
                <h3>FINANCIAL SERVICES</h3>
                <p>
                  VTT’s Financial Services Practice draws on deep industry
                  experience to help clients navigate a changing and highly
                  competitive industry
                </p>
                <li>Management Advisory</li>
                <li>Risk Advisory</li>
                <li>TDS</li>
                <li>Public & Private Sector</li>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-5-image.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list gray">
          <div className="row">
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-1-image.png" alt="" />
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-chart-area"></span>
                <h3>TAX</h3>
                <p>
                  VTT’s Consumer Business Practice understands the factors
                  reshaping the world of retail. Through assurance, tax, and
                  consulting services{" "}
                </p>
                <li>GST VAT</li>
                <li>Income Tax</li>
                <li>Sales Tax</li>
                <li>Service Tax</li>
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list">
          <div className="row">
            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-waves"></span>
                <h3>ACCOUNTING & GOVERNMENT CONTRACTING</h3>
                <p>
                  VTT draws on deep experience serving approximately 400
                  government contractor clients ranging from emerging businesses
                  to Fortune{" "}
                </p>

                <li>GST Accounting</li>
                <li>Service Tax Accounting</li>
                <li>Financial Reporting</li>
                <li>Company Services</li>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-3-image.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list gray">
          <div className="row">
            <div className="col-md-6">
              <div
                className="service-image wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-4-image.png" alt="" />
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-adjust-brightness"></span>
                <h3>REAL ESTATE & CONSTRUCTION</h3>
                <p>
                  VTT’s Real Estate and Construction Practice professionals
                  understand the changes and challenges facing the sector,{" "}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list">
          <div className="row">
            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-chart-bar"></span>
                <h3>NONPROFIT EDUCATION</h3>
                <p>
                  VTT presents innovative solutions to nonprofits organizations,
                  helping clients position their organizations to obtain proper
                  funding{" "}
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-2-image.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list gray">
          <div className="row">
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-6-image.png" alt="" />
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-arrow-shuffle"></span>
                <h3>PRIVATE-EQUITY</h3>
                <p>
                  VTT’s Private Equity Practice supports Private Equity
                  sponsors, funds, and their portfolio companies with a full
                  spectrum of{" "}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="services3-list">
          <div className="row">
            <div className="col-md-6">
              <div
                className="text-padding  wow zoomIn"
                data-wow-duration="500ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-chart-area"></span>
                <h3>PUBLIC-SECTOR</h3>
                <p>
                  VTT’s Public Sector Practice serves a wide variety of clients
                  across many levels of government. In addition to our Federal
                  Government clients,{" "}
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="service-image  wow fadeInUp"
                data-wow-duration="500ms"
                data-wow-delay="700ms"
              >
                <img src="images/services-7-image.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <div className="spacing-65"></div>
      </div>
    </>
  );
}

export default Services;
